import { cn } from '@/lib/utils'

/**
 * CMS-ийн rich editor-оос ирсэн HTML-ийг харуулна.
 *
 * ⚠️ Зөвхөн ЦЭВЭРЛЭСЭН HTML дамжуулна. Cloud тал нь HTMLPurifier-ээр
 * (`NewsController::BODY_PURIFIER`, `WebsiteStructureController::RICH_PURIFIER`)
 * цэвэрлэж өгдөг — өөр эх сурвалжийн HTML-ийг ХЭЗЭЭ Ч энд бүү оруул.
 *
 * Загварыг энд НЭГ л газар тодорхойлов: засварлагч дээр бичсэн бүх хэлбэр
 * (гарчиг, жагсаалт, ишлэл, холбоос, зураг, YouTube/Vimeo embed, тэгш
 * байрлуулалт) сайт дээр яг тэр хэвээрээ гарна. Tailwind-ийн `preflight`
 * нь `h2`, `ul`, `strong` зэргийн үндсэн загварыг тэглэдэг тул эдгээрийг
 * гараар буцааж өгөх ёстой — эс бөгөөс бүх зүйл ижил хэмжээний энгийн
 * текст болж харагдана.
 *
 * ⚠️ ХАМГИЙН ЖИЖИГ бичиг нь 20px (`text-xl`) — сайтын нэгдсэн доод хязгаар
 * ([[typography]]). Доорх дүрмүүдэд `text-xl`, `text-sm` гэх мэт түүнээс жижиг
 * утга БҮҮ нэм. Гарчиг нь өөрсдийн томоор дардаг.
 */
export const RichContent = ({ html, className }: { html: string; className?: string }) => (
  <div
    className={cn(
      'text-muted-foreground space-y-4 text-justify text-xl leading-relaxed hyphens-auto',

      // Гарчиг
      '[&_h1]:text-foreground [&_h1]:mt-8 [&_h1]:text-3xl [&_h1]:font-semibold [&_h1]:tracking-tight',
      '[&_h2]:text-foreground [&_h2]:mt-8 [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:tracking-tight',
      '[&_h3]:text-foreground [&_h3]:mt-6 [&_h3]:text-xl [&_h3]:font-semibold',

      // Догол мөр, онцлол
      '[&_strong]:text-foreground [&_em]:italic [&_s]:line-through [&_strong]:font-semibold [&_u]:underline',
      '[&_mark]:bg-primary/20 [&_mark]:text-foreground',

      // Жагсаалт
      '[&_li]:my-1 [&_ol]:list-decimal [&_ol]:ps-6 [&_ul]:list-disc [&_ul]:ps-6',

      // Ишлэл, зураас, код
      '[&_blockquote]:border-s-4 [&_blockquote]:ps-4 [&_blockquote]:italic',
      '[&_hr]:my-8 [&_hr]:border-t',
      '[&_code]:bg-muted [&_code]:rounded [&_code]:px-1.5 [&_code]:py-0.5',
      '[&_pre]:bg-muted [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:p-4',

      // Холбоос
      '[&_a]:text-foreground [&_a]:underline [&_a]:underline-offset-4 [&_a:hover]:no-underline',

      // Зураг ба видео embed
      /*
        Зургийн өргөнийг засварлагчаас (`style="width: 50%"`) тохируулж болно.
        Тиймээс `w-full` нь ЗӨВХӨН өргөн заагаагүй зурагт үйлчилнэ — эс бөгөөс
        утилити анги нь inline style-ыг дардаг ч биш, дарагдах ч биш болж
        админы тохируулга чимээгүй үл тоомсорлогдоно.
      */
      '[&_img]:my-6 [&_img]:h-auto [&_img]:max-w-full [&_img]:rounded-xl',
      '[&_img:not([style*="width"])]:w-full',
      '[&_.news-video]:relative [&_.news-video]:my-6 [&_.news-video]:aspect-video [&_.news-video]:w-full',
      '[&_.news-video>iframe]:absolute [&_.news-video>iframe]:inset-0 [&_.news-video>iframe]:size-full',
      '[&_.news-video>iframe]:rounded-xl',

      className
    )}
    dangerouslySetInnerHTML={{ __html: html }}
  />
)
